var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongKuaijiejian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-11A.5.5 0 012 13V3zM4.5 6.5h1M7.5 6.5h1M10.5 6.5h1M4.5 9.5h7",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_kuaijiejian.0a087d84.svg";
export { SvgTongyongKuaijiejian as ReactComponent };